import { render, staticRenderFns } from "./ShadowSection.vue?vue&type=template&id=1137a506"
import script from "./ShadowSection.vue?vue&type=script&lang=js"
export * from "./ShadowSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports